import React from "react";
import styles from "../Button.module.scss";

/**
 * This svg is a right arrow and uses css to rotate the arrow
 */

export const Arrow = ({ direction }) => {
  let classes = styles.leftArrow;

  if (direction === "right") {
    classes = styles.rightArrow;
  }

  return (
    <svg
      className={classes}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 20 20"
    >
      <title>Arrow</title>
      <g>
        <polygon points="10.9 0 8.5 2.3 13.6 7.4 0 7.4 0 10.6 13.6 10.6 8.5 15.7 10.9 18 20 9" />
      </g>
    </svg>
  );
};
